// extracted by mini-css-extract-plugin
export var addToCartButton = "_s2-b";
export var arrowButtonContainer = "_s2-9";
export var arrowButtonIcon = "_s2-a";
export var carouselArrowButton = "_s2-6";
export var carouselElementContainer = "_s2-1";
export var galleryThumbnail = "_s2-d";
export var galleryThumbnailImage = "_s2-e";
export var left = "_s2-7";
export var productDisplayCarouselContainer = "_s2-0";
export var productTileContainer = "_s2-2";
export var productTileImage = "_s2-4";
export var productTileImageContainer = "_s2-3";
export var productTileTitle = "_s2-5";
export var right = "_s2-8";
export var sliderOverflow = "_s2-c";